import { useEffect, useRef } from 'react';
import { useDashboardProps } from './DashboardContext';
import { EnvironmentDashboard } from './DemoDashboard';
import { ToursDashboard } from './ToursDashboard';

export const DashboardBody = () => {
  const { tab, handleScroll } = useDashboardProps();
  const scrollPositionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (scrollPositionRef.current) {
      scrollPositionRef.current.scrollTo({ top: 0 });
    }
  }, [tab]);

  return (
    <div
      className="flex flex-col items-center pb-9 overflow-auto w-full"
      onScroll={handleScroll}
      ref={scrollPositionRef}
    >
      {tab === 'demo' ? <EnvironmentDashboard /> : <ToursDashboard />}
    </div>
  );
};
